import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from "react-router-dom";
import { Checkbox, Select, Modal, Spinner } from '../Common';
import readFile from '../../utils/readFile';
import _ from 'lodash';
import {
    getMemoryChargedData,
    getMesObsequesData,
    getLegalInformationData,
    getObituaryData,
    sendCollectionWills,
    download
} from '../../api/api';
import Loader from '../Loader';
import { pushToDataLayer } from '../../utils/gtmUtils';

export class RecapPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showText: false,
            autorisation: false,
            CollectionWillsSended: false,
            role: JSON.parse(sessionStorage.getItem('auth')).role,
            beneficiaireLightsList: [],
            loader: false,
            displayModal: 'inactive',
            downloadUrl: null,
            videoSpinner: 'inactive',
            idBeneficiaire : '',
        }
    }

    componentWillMount() {
        if (this.state.role != 'MC')
            this.getData();
        else if (this.state.role == 'MC' && this.props.beneficiary.beneficiaireLights.length === 1) {
            this.getData(this.props.beneficiary.beneficiaireLights[0].idBeneficiaire);
            this.setState({ idBeneficiaire : this.props.beneficiary.beneficiaireLights[0].idBeneficiaire })
        }
        else {
            let beneficiaireLightsList = [{
                idBeneficiaire: 0, libelle: 'Veillez choisir un compte'
            }];
            this.props.beneficiary.beneficiaireLights.map(item =>
                beneficiaireLightsList.push({ idBeneficiaire: item.idBeneficiaire, libelle: item.nom + ' ' + item.prenom }))
            this.setState({ beneficiaireLightsList });
        }
    }

    getData = (idBeneficiaire) => {
        const benfId = idBeneficiaire ? idBeneficiaire : this.props.beneficiary.idBeneficiaire
        const self = this;
        let data = {}
        self.setState({ loader: true });
        return Promise.all(
            [getMemoryChargedData(benfId, this.props.partenaireData.id)
                , getMesObsequesData(benfId, this.props.partenaireData.id)
                , getLegalInformationData(benfId, this.props.partenaireData.id)
                , getObituaryData(benfId, this.props.partenaireData.id)
            ]).then(list => {
                data.MC = _.find(list[0].data, { role: "memoryCharged" });
                data.AC = _.find(list[0].data, { role: "alternateMemoryCharged" });
                data.DC = _.find(list[0].data, { role: "digitalCharged" });
                data.ceremonie = list[1].data.ceremonie;
                data.ceremonie.texteCeremonie
                data.care = list[1].data.typeSoinConservation;
                data.otherDispo = list[1].data.autres;
                data.legalInfo = list[2].data;
                data.obituary = list[3].data;
                if (data.obituary.listToInform) {
                    data.obituary.listToInform = _.sortBy(data.obituary.listToInform, 'name');
                    data.people = _.filter(data.obituary.listToInform, { type: "NATURAL" })
                    data.organism = _.filter(data.obituary.listToInform, { type: "LEGAL" });
                }
                if (data.obituary.newspapers)
                    data.obituary.newspapers = data.obituary.newspapers.sort();
                self.setState({ data: data });
            });
    }

    handleOnChange(key, e) {
        let value = e.target.checked ? true : false;
        this.setState(() => ({ [key]: value }));
    }

    onChangeBenef = (e) => {
        const idBeneficiaire = e.target.value ;
        this.setState({ idBeneficiaire })
        this.getData(idBeneficiaire);
    }

    actionType = fileName => {
        const ext = fileName.split('.')[fileName.split('.').length - 1];
        const images = ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'];
        if (images.indexOf(ext) > -1)
            return 'download';
        return 'video';
    }


    getFile = (fileName) => {
        let data = {}
        const idBeneficiaire = (this.state.role == 'MC') ? this.state.idBeneficiaire : this.props.beneficiary.idBeneficiaire ;
        data.file = `${idBeneficiaire}/${fileName}` 
        if (this.state.role == 'MC')
            data.memoryChargedId = this.props.beneficiary.idBeneficiaire ;
        download(data, this.props.partenaireData.id).then(data => {
            readFile(data.response, fileName, data.type, 'text');
        }, error => {
            // handle errors
        });
    }

    playVideo = (videoName, action) => {
        if (action == 'video') {
            this.setState({ displayModal: 'active' });
            window.scrollTo(0, 0);
        } else {
            this.setState({ videoSpinner: 'active' });
        }
        let data = {}
        const idBeneficiaire = (this.state.role == 'MC') ? this.state.idBeneficiaire : this.props.beneficiary.idBeneficiaire ;
        data.file = `${idBeneficiaire}/${videoName}` 
        if (this.state.role == 'MC')
            data.memoryChargedId = this.props.beneficiary.idBeneficiaire ;
        download(data, this.props.partenaireData.id).then(data => {
            readFile(data.response, videoName, data.type, action);
            this.setState({ videoSpinner: 'inactive' });
        }, error => {
            // handle errors
        });
    }

    closeModal = () => {
        this.setState({ displayModal: 'inactive' });
    }

    starSendCollectionWills = () => {
        const dataLayer = {
            event: "sendCollectionWills",
            url: window.location.href,
            idPartenaire: this.props.partenaireData.id
        }
        pushToDataLayer(dataLayer);
        sendCollectionWills(this.props.beneficiary.idBeneficiaire, this.props.partenaireData.id).then((response) => {
            this.setState({ CollectionWillsSended: true });
        }, error => {
            console.log(error);
        })
    }

    render() {
        return (
            <div className="recap-page container main-container">
                <Modal status={this.state.displayModal}>
                    <div onClick={this.closeModal} className="close">X</div>
                    <video poster="/images/video-loader.gif" preload="auto" controls autoPlay ></video>
                </Modal>
                {this.state.role != 'MC' &&
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Accueil</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Récapitulatif de votre recueil</li>
                    </ol>
                }
                <h1 className={this.state.role == 'MC' ? "text-center margin-top" : "text-center"} >
                    {this.state.role == 'MC' ? "Récapitulatif d'un recueil" : "Récapitulatif de votre recueil"}
                </h1>
                {!this.state.CollectionWillsSended && this.state.role != 'MC' &&
                    <div className="intro-text">
                        Avant d'envoyer votre recueil de mémoire définitif à {this.props.partenaireData.marqueAllianzPartners}, vous avez encore la possibilité
                        de modifier les rubriques ci-dessous.
                    </div>
                }
                {
                    this.props.beneficiary.beneficiaireLights && this.props.beneficiary.beneficiaireLights.length > 1 &&
                    <Select
                        label=" "
                        _className={"form-control address "}
                        value={this.state.idBeneficiaire}
                        onChange={this.onChangeBenef}
                        list={this.state.beneficiaireLightsList}
                        selectType="obj"
                        defaultValue="0"
                        optionValue="idBeneficiaire"
                        optionLabel="libelle"

                    />
                }
                {
                    this.state && this.state.data ?
                        !this.state.CollectionWillsSended ?
                            <div className="container man-container">
                                <div className="row">
                                    <div className="col">
                                        <h5>I - Mes chargés de Mémoire </h5>
                                    </div>
                                    <div className="col">
                                        {this.state.role != 'MC' &&
                                            <div className="button-container">
                                                <Link to="/charges-de-memoire"><button type="button" className="btn btn-primary"><span>➜</span>Modifier</button></Link>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td className="first-rd" style={{ width: '18%' }} ></td>
                                            <td style={{ width: '22%' }} className="memory-title">Chargé de mémoire</td>
                                            <td style={{ width: '35%' }} className="memory-title">Chargé de mémoire <br />suppléant</td>
                                            <td style={{ width: '25%' }} className="memory-title">Chargé <br />numérique</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td >Nom</td>
                                            <td>{this.state.data && this.state.data.MC && this.state.data.MC.nom}</td>
                                            <td>{this.state.data && this.state.data.AC && this.state.data.AC.nom}</td>
                                            <td>{this.state.data && this.state.data.DC && this.state.data.DC.nom}</td>
                                        </tr>
                                        <tr>
                                            <td>Prénom</td>
                                            <td>{this.state.data && this.state.data.MC && this.state.data.MC.prenom}</td>
                                            <td>{this.state.data && this.state.data.AC && this.state.data.AC.prenom}</td>
                                            <td>{this.state.data && this.state.data.DC && this.state.data.DC.prenom}</td>
                                        </tr>
                                        <tr>
                                            <td>Date de naissance</td>
                                            <td>{this.state.data && this.state.data.MC && moment(this.state.data.MC.dateNaissance.epochSecond * 1000).format('DD/MM/YYYY')}</td>
                                            <td>{this.state.data && this.state.data.AC && moment(this.state.data.AC.dateNaissance.epochSecond * 1000).format('DD/MM/YYYY')}</td>
                                            <td>{this.state.data && this.state.data.DC && moment(this.state.data.DC.dateNaissance.epochSecond * 1000).format('DD/MM/YYYY')}</td>
                                        </tr>
                                        <tr>
                                            <td>Adresse</td>
                                            <td>
                                                {this.state.data && this.state.data.MC && this.state.data.MC.address}
                                                <br />
                                                {this.state.data && this.state.data.MC && this.state.data.MC.codePostal}
                                                &nbsp;
	                                        	{this.state.data && this.state.data.MC && this.state.data.MC.ville}
                                            </td>
                                            <td>
                                                {this.state.data && this.state.data.AC && this.state.data.AC.address}
                                                <br />
                                                {this.state.data && this.state.data.AC && this.state.data.AC.codePostal}
                                                &nbsp;
	                                        	{this.state.data && this.state.data.AC && this.state.data.AC.ville}
                                            </td>
                                            <td>
                                                {this.state.data && this.state.data.DC && this.state.data.DC.address}
                                                <br />
                                                {this.state.data && this.state.data.DC && this.state.data.DC.codePostal}
                                                &nbsp;
	                                        	{this.state.data && this.state.data.DC && this.state.data.DC.ville}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Numéro de téléphone</td>
                                            <td>{this.state.data && this.state.data.MC && this.state.data.MC.telephone}</td>
                                            <td>{this.state.data && this.state.data.AC && this.state.data.AC.telephone}</td>
                                            <td>{this.state.data && this.state.data.DC && this.state.data.DC.telephone}</td>
                                        </tr>
                                        <tr>
                                            <td>Adresse de messagerie</td>
                                            <td>{this.state.data && this.state.data.MC && this.state.data.MC.email}</td>
                                            <td>{this.state.data && this.state.data.AC && this.state.data.AC.email}</td>
                                            <td>{this.state.data && this.state.data.DC && this.state.data.DC.email}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {this.state.data && this.state.data.DC && this.state.data.DC.profils && this.state.data.DC.profils[0] &&
                                    <div className="title-tab">Comptes à clôturer</div>
                                }
                                <table className="table table-bordered align-left">
                                    <tbody>
                                        {this.state.data && this.state.data.DC && this.state.data.DC.profils && this.state.data.DC.profils.map((item, i) =>
                                            item &&
                                            <tr key={i}>
                                                <td>{item}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className="row">
                                    <div className="col">
                                        <h5>II - Mes Obsèques </h5>
                                    </div>
                                    <div className="col">
                                        {this.state.role != 'MC' &&
                                            <div className="button-container">
                                                <Link to="/mes-obseques"><button type="button" className="btn btn-primary"><span>➜</span>Modifier</button></Link>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="title-tab">Cérémonie</div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '40%' }}>Type de cérémonie</td>
                                            <td>
                                                {this.state.data.ceremonie &&
                                                    this.state.data.ceremonie.typeCeremonie}
                                            </td>
                                        </tr>
                                        {this.state.data.ceremonie && this.state.data.ceremonie.typeCeremonie.toUpperCase() == "AUTRE" &&
                                        <tr>
                                            <td style={{ width: '40%' }}>Commentaires</td>
                                            <td>
                                                {this.state.data.ceremonie &&
                                                    this.state.data.ceremonie.texteAutre}
                                            </td>
                                        </tr>
                                        }
                                        {this.state.data.ceremonie.typeCeremonie.toUpperCase() != "AUTRE" &&
                                        <tr>
                                            <td>Lieu de la cérémonie</td>
                                            <td>
                                                {this.state.data.ceremonie.addresseCeremonie + ' - ' +
                                                    this.state.data.ceremonie.codePostalCeremonie + ' - ' +
                                                    this.state.data.ceremonie.villeCeremonie + ' - '

                                                }
                                                {
                                                    _.find(this.props.countryData, { id: this.state.data.ceremonie.paysCeremonie })
                                                    && _.find(this.props.countryData, { id: this.state.data.ceremonie.paysCeremonie }).libelle
                                                }
                                            </td>
                                        </tr>
                                        }
                                        <tr>
                                            <td>Rite funéraire</td>
                                            <td>
                                                {this.state.data.ceremonie.incineration && this.state.data.ceremonie.incineration.modeDispersionCendres &&
                                                    <span>
                                                        Incineration dans
                                                        {this.state.data.ceremonie.incineration.modeDispersionCendres === "CIMETIERE" && ' un cimetière'}
                                                        {this.state.data.ceremonie.incineration.modeDispersionCendres === "NATURE" && ' la nature'}
                                                        {this.state.data.ceremonie.incineration.modeDispersionCendres === "MER" && ' la mer'}
                                                    </span>
                                                }
                                                {this.state.data.ceremonie.incineration && this.state.data.ceremonie.incineration.remiseUrne && 
                                                    <span>
                                                        Je souhaite que mes cendres soient
                                                        {this.state.data.ceremonie.incineration.remiseUrne === "FAMILLE" && ' remises à ma famille'}
                                                        {this.state.data.ceremonie.incineration.remiseUrne === "COLUMBARIUM" && ' remises au columbarium'}
                                                        {this.state.data.ceremonie.incineration.remiseUrne === "CAVEAU" && ' deposées dans mon caveau'}
                                                    </span>
                                                }
                                                {this.state.data.ceremonie.enterrement && this.state.data.ceremonie.enterrement.cimetiere != null &&
                                                    <span>
                                                        Inhumation dans un cimetière
                                                    </span>
                                                }
                                                {this.state.data.ceremonie.enterrement && this.state.data.ceremonie.enterrement.cimetiere == null &&
                                                    <span>
                                                        Inhumation hors cimetière
                                                    </span>
                                                }
                                            </td>
                                        </tr>
                                        {this.state.data.ceremonie.incineration && this.state.data.ceremonie.incineration.modeDispersionCendres === "CIMETIERE" &&
                                            <tr>
                                                <td>Lieu du rite funéraire</td>
                                                <td>
                                                    { 
                                                        this.state.data.ceremonie.incineration.addresseCimetiere + ' - '
                                                        + this.state.data.ceremonie.incineration.codePostalCimetiere + ' - '
                                                        + this.state.data.ceremonie.incineration.villeCimetiere + ' - '
                                                    }
                                                    {
                                                        _.find(this.props.countryData, { id: this.state.data.ceremonie.incineration.paysCimetiere })
                                                        && _.find(this.props.countryData, { id: this.state.data.ceremonie.incineration.paysCimetiere }).libelle
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        {this.state.data.ceremonie.enterrement &&
                                            <tr>
                                                <td>Lieu du rite funéraire</td>
                                                <td>
                                                    {
                                                        this.state.data.ceremonie.enterrement.addresseCimetiere + ' - '
                                                        + this.state.data.ceremonie.enterrement.codePostalCimetiere + ' - '
                                                        + this.state.data.ceremonie.enterrement.villeCimetiere + ' - '
                                                    }
                                                    {
                                                        _.find(this.props.countryData, { id: this.state.data.ceremonie.enterrement.paysCimetiere })
                                                        && _.find(this.props.countryData, { id: this.state.data.ceremonie.enterrement.paysCimetiere }).libelle
                                                    }
                                                </td>
                                            </tr>
                                        }
                                        <tr>
                                            <td>Concession</td>
                                            <td>{this.state.data.ceremonie.enterrement && this.state.data.ceremonie.enterrement.concession ? 'Oui' : 'Non'}</td>
                                        </tr>
                                        <tr>
                                            <td>Caveau de famille</td>
                                            <td>{this.state.data.ceremonie.enterrement && this.state.data.ceremonie.enterrement.caveauFamiliale ? 'Oui' : 'Non'}</td>
                                        </tr>
                                        {this.state.data.ceremonie.texteCeremonie &&
                                            <tr>
                                                <td>Texte à lire</td>
                                                <td> {this.state.data.ceremonie
                                                    && this.state.data.ceremonie.texteCeremonie
                                                    && this.state.data.ceremonie.texteCeremonie.filename
                                                    &&
                                                    <div className="Link-text" onClick={() => this.getFile(this.state.data.ceremonie.texteCeremonie && this.state.data.ceremonie.texteCeremonie.filename)}>
                                                        Télécharger le texte
                                                    </div>
                                                }
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                
                                {this.state.data.ceremonie.music && this.state.data.ceremonie.music.length > 0 && 
                                    <div>
                                        <div className="title-tab">Musique à diffuser</div>
                                        <table className="table table-bordered">
                                        	<thead>
		                                        <tr>
		                                        <td style={{ width: '40%' }}>Auteur</td>
		                                        <td style={{ width: '60%' }}>Titre</td>
		                                        </tr>
		                                    </thead>
                                            <tbody>
                                                { this.state.data.ceremonie.music.map((item, i) =>
                                                        <tr key={i}>
                                                            <td>{item.auteur}</td>
                                                            <td>{item.titre}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }

                                <div className="title-tab">Soins de conservation</div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '40%' }}>Soins de conservation</td>
                                            <td>{this.state.data.care}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="title-tab">Autres dispositions</div>
                                <table className="table table-bordered">
                                    <tbody>
                                        {this.state.data.otherDispo
                                            && this.state.data.otherDispo.ceremonieVisuelTitre
                                            && this.state.data.otherDispo.ceremonieVisuelTitre.filename
                                            && this.state.data.otherDispo.ceremonieVisuelTitre.filename
                                            && (this.actionType(this.state.data.otherDispo.ceremonieVisuelTitre.filename) === "video")
                                            ?
                                            <tr>
                                                <td style={{ width: '40%' }}>Vidéo à diffuser après la cérémonie</td>
                                                <td>
                                                    <div className="video-container">
                                                        <div className="Link-text" onClick={() => this.playVideo(this.state.data.otherDispo.ceremonieVisuelTitre && this.state.data.otherDispo.ceremonieVisuelTitre.filename, 'video')}>
                                                            Lire la vidéo
                                                </div>
                                                        <a className="round-btn btn-download" onClick={() => this.playVideo(this.state.data.otherDispo.ceremonieVisuelTitre && this.state.data.otherDispo.ceremonieVisuelTitre.filename, 'download')}>
                                                            <img src="/images/download-icon.png" width="13" height="15" />
                                                        </a>
                                                        <Spinner status={this.state.videoSpinner} />
                                                    </div>

                                                </td>
                                            </tr>
                                            :
                                            <tr>
                                                <td style={{ width: '40%' }}>Image à diffuser après la cérémonie</td>
                                                <td>
                                                    <div className="video-container">
                                                        { this.state.data.otherDispo.ceremonieVisuelTitre && this.state.data.otherDispo.ceremonieVisuelTitre.filename &&
                                                            <div className="Link-text" onClick={() => this.playVideo(this.state.data.otherDispo.ceremonieVisuelTitre && this.state.data.otherDispo.ceremonieVisuelTitre.filename, 'download')}>
                                                                Télécharger l'image
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                        <tr>
                                            <td >Prise en charge des animaux</td>
                                            <td>
                                                {
                                                    this.state.data.otherDispo
                                                    && this.state.data.otherDispo.responsibleAnimal && this.state.data.otherDispo.responsibleAnimal.nom && this.state.data.otherDispo.responsibleAnimal.prenom &&
                                                    <span>
                                                        {
                                                            this.state.data.otherDispo.responsibleAnimal.nom + ' ' +
                                                            this.state.data.otherDispo.responsibleAnimal.prenom
                                                        }
                                                    </span>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col">
                                        <h5>III - Mes Informations Juridiques </h5>
                                    </div>
                                    <div className="col">
                                        {this.state.role != 'MC' &&
                                            <div className="button-container">
                                                <Link to="/informations-juridiques"><button type="button" className="btn btn-primary"><span>➜</span>Modifier</button></Link>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '40%' }}>Testament rédigé</td>
                                            <td>
                                                {
                                                    this.state.data.legalInfo &&
                                                        this.state.data.legalInfo.testament ?
                                                        `Oui, le testament a été rédigé chez un notaire/exécuteur testamentaire`
                                                        :
                                                        `Non, aucun testament n'a été rédigé `
                                                }
                                            </td>
                                        </tr>
                                        { this.state.data.legalInfo &&
                                            this.state.data.legalInfo.testament &&
                                            <tr>
                                                <td>Nom du notaire/exécuteur testamentaire</td>
                                                <td>{this.state.data.legalInfo.firstName + ' ' + this.state.data.legalInfo.name}</td>
                                            </tr>
                                        }
                                        { this.state.data.legalInfo &&
                                            this.state.data.legalInfo.testament &&
                                            <tr>
                                                <td>Adresse du notaire/exécuteur testamentaire</td>
                                                <td>{this.state.data.legalInfo.address + ' ' + this.state.data.legalInfo.zipCode + ' ' + this.state.data.legalInfo.city}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                <div className="row">
                                    <div className="col">
                                        <h5>IV - Mon Avis de décès </h5>
                                    </div>
                                    <div className="col">
                                        {this.state.role != 'MC' &&
                                            <div className="button-container">
                                                <Link to="/avis-deces"><button type="button" className="btn btn-primary"><span>➜</span>Modifier</button></Link>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="title-tab">Mon avis de décès</div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '40%' }}>Avis de décès</td>
                                            <td>{this.state.data.obituary.displayObituary ?
                                                <span> Oui ( <span
                                                    className="Link-text"
                                                    onClick={() => this.setState({ showText: !this.state.showText })}>
                                                    {this.state.showText ? 'Masquer le texte' : 'Voir le texte'}
                                                </span> ) </span>
                                                :
                                                'Non'
                                            }
                                                {this.state.showText &&
                                                    <p> {this.state.data.obituary.obituaryText}</p>
                                                }
                                            </td>
                                        </tr>
                                        {this.state.data.obituary.newspapers &&
                                            <tr>
                                                <td style={{ width: '40%' }}>Journaux</td>
                                                <td>{this.state.data.obituary.newspapers.map(function (item, key) {
                                                    return (<div key={key}>{item}</div>)
                                                })}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                {this.state.data.people &&
                                    <div>
                                        <div className="title-tab">Personnes à informer</div>
                                        <table className="table table-bordered">
                                            <tbody>
                                                {
                                                    this.state.data.people.map((item, i) =>
                                                        <tr key={i}>
                                                            <td style={{ width: '20%' }}>{item.name}</td>
                                                            <td style={{ width: '20%' }}>{item.firstName}</td>
                                                            <td style={{ width: '30%' }}>{item.tel}</td>
                                                            <td style={{ width: '30%' }}>{item.email}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                {this.state.data.organism &&
                                    <div>
                                        <div className="title-tab">Organismes à contacter</div>
                                        <table className="table table-bordered">
                                            <tbody>
                                                {
                                                    this.state.data.organism.map((item, i) =>
                                                        <tr key={i}>
                                                            <td style={{ width: '40%' }}>{item.name}</td>
                                                            <td style={{ width: '30%' }}>{item.tel}</td>
                                                            <td>{item.email}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                <div className="col-sm-12  form-container align-center">
                                    <div className="button-container">
                                        {this.state.role != 'MC' ?
                                            <button type="button" className="btn  btn-primary" onClick={this.starSendCollectionWills} >Envoyer le recueil</button>
                                            :
                                            <button type="button" className="btn  btn-primary" onClick={() => window.print()} >Imprimer le recueil</button>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="bloc-from_success">
                                <img src='/images/yes.png' alt="image" />
                                <p className="validation-txt">
                                    Votre recueil de mémoire a été bien envoyé, vous allez recevoir un mail de confirmation.
                                </p>
                                <Link to="/"><button type="button" className="btn btn-primary btn-back">Accueil</button></Link>
                            </div>
                        :
                        this.state.loader &&
                        <Loader />
                }

            </div>
        )
    }
}


const mapStateToProps = state => ({
    beneficiary: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
    //ceremonyData: state.ceremonyData,
    countryData: state.countryData.list,
    partenaireData: state.partenaireData
})

export default connect(mapStateToProps, undefined)(RecapPage);




// WEBPACK FOOTER //
// ./src/components/Recap/RecapPage.js